import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ICaseList } from 'src/app/classes/case-list';
import { PublicService } from 'src/app/services/public.service';
import * as theGlobals from "../globals";

@Component({
    selector: 'app-case-lookup',
    templateUrl: './case-lookup.component.html'
})
export class CaseLookupComponent implements OnInit {

    caseList: ICaseList[];
    cols: any[];
    //
    displayState: any = {
        workingDiv: false,
        filterDiv: false,
        gridDiv: false,
        noCaseFound: false,
        caseDiv: false
    };

    searchString = {
        caseNum: '',
        APN: '',
        applicant: '',
        propStreetAddr: ''
    };
    selCase = {
      CaseNumber: '',
      APN: '',
      ApplicantName: '',
      Status: '',
      Hearing: '',
      Location: ''
    }
  copyYear = new Date().getFullYear();
  versionNumber = theGlobals.versionNum;


    constructor(private publicService: PublicService, private router: Router,
                private route: ActivatedRoute) { }

    ngOnInit() {
        this.cols = [
            { field: 'caseNumber', header: 'Case Number' },
            // { field: 'applicantName', header: 'Applicant' },
            { field: 'situs', header: 'Situs'},
            { field: 'city', header: 'City' },
            { field: 'propNumber', header: 'APN' },

        ];
      this.displayState.filterDiv = true;
        //
    }
    goHome() {
      this.router.navigate(['/home']);
    }
    // go back to the Search menu
    goSearch() {
      this.clearSearch();
      this.displayState = {
        workingDiv: false,
        gridDiv: false,
        noCaseFound: false,
        caseDiv: false,
        filterDiv: true
      }
      return;
    }
    // execute search based on what field they've filled in; only takes the FIRST field based on screen order
    runSearch(searchType: string = "") {
      let searchDto = {
        searchType: "",
        CaseNumber: "",
        ApplicantName: "",
        PropNumber: "",
        Situs: ""
      }
      if (!searchType) {
        if (this.searchString.caseNum) {
          searchType="casenum";
        } else if (this.searchString.APN) {
          searchType="apn";
        } else if (this.searchString.propStreetAddr) {
          searchType="situs";
        } else if (this.searchString.applicant) {
          searchType="applicant";
        } else {
          alert('No search filters specified!');
          return;
        }
      }
      // make sure they've entered a value for the specified field
      if (searchType == "casenum") {
        if (!this.searchString.caseNum) {
          alert('No Case Number Specified!');
          return;
        }
        searchDto.CaseNumber = this.searchString.caseNum;
      } else if (searchType == "apn") {
        const apn = this.searchString.APN.replace(/-/g, '');
        if (!apn) {
          alert('No APN Specified!');
          return;
        }
        searchDto.PropNumber = apn;
      } else if (searchType == "situs") {
        if (!this.searchString.propStreetAddr) {
          alert('No Property Street Address Specified!');
          return;
        }
        searchDto.Situs = this.searchString.propStreetAddr;
      } else if (searchType == "applicant") {
        if (!this.searchString.applicant) {
          alert('No Applicant Specified!');
          return;
        }
        searchDto.ApplicantName=this.searchString.applicant;
      }
      //
      searchDto.searchType = searchType;
      this.searchForCase(searchDto);
    }

  searchForCase(searchObj: any) {
    this.displayState.gridDiv = false;
    this.displayState.workingDiv = true;
    this.publicService.doAudit(searchObj, 'search case on:');
    this.publicService.searchCase(searchObj).subscribe(data => {
      this.publicService.doAudit(data, 'response from searchCase');
      this.displayState.workingDiv = false;
      if (data) {
        this.caseList = data;
        if (data.length < 1) {
          this.noCaseFound();
          return;
        } else if (data.length === 1) {
          this.onSelect(data[0]); // if only ONE hit, got directly to the Case screen!
          // this.displayState.gridDiv = true;
        } else {
          this.displayState.gridDiv = true;
        }
        this.displayState.filterDiv = false;
      }
    });
  }
  // display "no cases found" message...
  noCaseFound() {
    this.displayState = {
      workingDiv: false,
      filterDiv: false,
      gridDiv: false,
      noCaseFound: true
    }
    return;
  }
    clearSearch() {
      this.searchString = {
        caseNum: '',
        APN: '',
        propStreetAddr: '',
        applicant: ''
      }
      return;
    }
    // display select case data; as another "div" or go to a separate module??
    onSelect(myCase: ICaseList) {
        const id = myCase.id;
        this.publicService.getCaseStatusAndHearingInfo(id).subscribe(data => {
          this.publicService.doAudit(data, 'response from getCaseStatusAndHearingInfo');
          if (data) {
            this.selCase = {
              CaseNumber: myCase.caseNumber,
              APN: myCase.propNumber,
              ApplicantName: myCase.applicantName,
              Status: data.status,
              Hearing: data.hearingDate ? new Date(data.hearingDate).toDateString() + ' ' + data.hearingTime: '',
              Location: data.meetingLocation ? data.meetingLocation.location + ' - \n' + data.meetingLocation.location2 : '',
            };
            this.displayState.gridDiv = false;
            this.displayState.caseDiv = true;
          }
        });
    }
}
